import { jsx } from "react/jsx-runtime";
import { Box, StyledList } from "@zillow/constellation";
import PropTypes from "prop-types";
import "react";
import { negativeMarginMixin } from "../../mixins/negativeMarginMixin.esm.js";
import { ListContext } from "./ListContext.esm.js";
import ListItem from "./ListItem.esm.js";
const List = (props) => {
  const {
    attrs,
    appearance
  } = props;
  let listStyleType;
  if (appearance === "bullet") {
    listStyleType = "disc";
  } else if (appearance === "number") {
    const styleAttr = attrs == null ? void 0 : attrs.find((attr) => attr.name === "style");
    const styleValue = (styleAttr == null ? void 0 : styleAttr.value) || "";
    const listStyleMatch = styleValue.match(/list-style-type:\s*([^;]+)/);
    listStyleType = listStyleMatch ? listStyleMatch[1].trim() : "decimal";
  }
  return /* @__PURE__ */ jsx(ListContext.Provider, { value: props, children: /* @__PURE__ */ jsx(Box, { as: StyledList, ...props, sx: {
    // Apply negative margin mixin and inherit color
    "&&&&&": {
      ...negativeMarginMixin,
      listStyleType
    },
    color: "inherit"
  } }) });
};
List.Item = ListItem;
List.propTypes = {
  children: PropTypes.shape({}),
  appearance: PropTypes.oneOf(["number", "checkmark", "bullet", "horizontalTable", "none"]),
  verticalSpace: PropTypes.oneOf([0, "xs", "sm", "md", "lg", "xl", "xxl", "xxxl"])
};
List.defaultProps = {
  appearance: "bullet",
  verticalSpace: "none"
};
export {
  List as default
};
